import { lazy } from 'react';

import { Route, Routes, useLocation } from 'react-router-dom';

import { ProtectedRoute } from '@packages/components/protected-route/protected-route';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

const EscalationListPage = lazy(
  () => import('./escalation-list/escalation-list.page'),
);

const EscalationDetailPage = lazy(
  () => import('./escalation-detail/escalation-detail.page'),
);

const EditEscalationDetailPage = lazy(
  () => import('./escalation-detail/edit-escalation-detail.page'),
);

const AddEscalationDetailPage = lazy(
  () => import('./escalation-detail/add-escalation-detail.page'),
);

export const EscalationsRoutes = () => {
  const [selfServeFF] = useFeatureFlag('SELF_SERVE_ESCALATIONS');
  const location = useLocation();

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute
            subscriptions={{
              managedRisk: true,
              managedDetectionResponse: true,
            }}
          />
        }
      >
        {
          // This is a temporary fix until https://arcticwolf.atlassian.net/browse/S2CX-7116 is resolved
          // Once the real fix is in place, we will have a separate Route for the detail page
          typeof location.state?.escalationIndex === 'number' ? (
            <Route index element={<EscalationDetailPage />} />
          ) : (
            <Route index element={<EscalationListPage />} />
          )
        }

        <Route path="/:escalationId">
          <Route index element={<EscalationDetailPage />} />
          {selfServeFF && (
            <Route path="edit" element={<EditEscalationDetailPage />} />
          )}
        </Route>
        {selfServeFF && (
          <Route element={<AddEscalationDetailPage />} path="new" />
        )}
      </Route>
    </Routes>
  );
};
